var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_LONG_READ_REQUEST, GET_LONG_READ_SUCCESS, GET_LONG_READ_ERROR } from '../actions/getLongRead';
var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getLongReadReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_LONG_READ_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_LONG_READ_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_LONG_READ_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getLongRead.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_LONG_READ_REQUEST, GET_LONG_READ_SUCCESS, GET_LONG_READ_ERROR } from '../actions/getLongRead';
var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getLongReadReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_LONG_READ_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_LONG_READ_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_LONG_READ_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getLongRead.js.map